<template>
  <el-container>
    <!-- 导出对话框 -->
    <el-dialog
      :title="outputdlg.title"
      :visible.sync="outputdlg.visible"
      :width="outputdlg.width"
    >
      <el-card class="box-card">
        <el-form
          :model="outputdlg"
          ref="outputRef"
          status-icon
          label-width="80px"
        >
          <el-form-item label="导出类型" prop="selectType">
            <el-radio-group v-model="outputdlg.selectType">
              <el-radio :label="0">工单列表</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="时间区间" prop="dateRangeValue">
            <el-date-picker
              v-model="outputdlg.dateRangeValue"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="工单类型" prop="pstType">
            <el-select
              v-model="outputdlg.pstTypes"
              placeholder="请选择"
              multiple
              collapse-tags
            >
              <el-option
                v-for="pstType in pstApi.pstTypes.filter(
                  (item) => item.value != -1
                )"
                :key="pstType.value"
                :label="pstType.title"
                :value="pstType.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工单状态" prop="categorys">
            <el-select
              v-model="outputdlg.categorys"
              placeholder="请选择"
              filterable
              multiple
              collapse-tags
            >
              <el-option
                v-for="order in pstApi.pstorders"
                :key="order.value"
                :label="order.title"
                :value="order.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="output()"
          :disabled="outputdlg.dateRangeValue == null"
          >导 出</el-button
        >
        <el-button @click="outputdlg.visible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 主体内容 -->
    <el-header
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>工单列表</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button
          type="info"
          icon="el-icon-download"
          @click.native="outputdlg.visible = true"
          >导出Excel</el-button
        >
      </el-button-group>
    </el-header>

    <el-main>
      <div>
        <!-- 查询工具栏-->
        <div class="cust_seach">
          <el-select
            v-model="query.pstType"
            placeholder="请选择"
            class="btnLeft"
            @change="querySubmit()"
          >
            <el-option
              v-for="pstType in pstApi.pstTypes"
              :key="pstType.value"
              :label="pstType.title"
              :value="pstType.value"
            >
            </el-option>
          </el-select>
          <el-select
            multiple
            collapse-tags
            style="margin-left: 20px"
            v-model="query.categorys"
            placeholder="请选择"
            class="btnStatus"
            @change="querySubmit()"
          >
            <el-option
              v-for="category in pstApi.categorys.filter(
                (item) =>
                  item.value != -10 &&
                  item.value != -2 &&
                  item.value != 0 &&
                  item.value != 3 &&
                  item.value != 4 &&
                  item.value != 6
              )"
              :key="category.value"
              :label="category.transferTitle"
              :value="category.value"
            >
            </el-option>
          </el-select>
          <el-input
            class="btnTitle"
            suffix-icon="el-icon-search"
            v-model="query.queryString"
            placeholder="请输入模糊字段"
            @input="querySubmit"
          />

          <!-- <el-button-group>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="querySubmit"
            />
          </el-button-group> -->
        </div>
        <el-table :data="data.psts">
          <el-table-column
            prop="postingTime"
            label="发贴时间"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{ Common.dateFormatter(scope.row.postingTime, "yyyy-MM-dd") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="发贴人"
            width="150"
            align="center"
          />
          <el-table-column prop="title" label="标题">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="small" @click="details(scope.row)">
                  {{ scope.row.title }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="pstSource"
            label="舆情来源"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                <a :href="scope.row.pstUrl" target="_blank">{{
                  scope.row.pstSource
                }}</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="lastTime"
            label="办理时间"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span v-html="getColorTime(scope.row)" />
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.status === 1 || scope.row.status === 5
                    ? 'success'
                    : 'info'
                "
                disable-transitions
                >{{ pstApi.getStatusTransferTitle(scope.row.status) }}</el-tag
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="cust_pagin">
          <el-pagination
            layout="prev, pager, next"
            :total="xpagination.totalCount"
            :page-size="xpagination.pageSize"
            :current-page="xpagination.pageNumber"
            @current-change="handleCurrentChange"
            hide-on-single-page
            :background="true"
          />
        </div>
      </div>
    </el-main>
  </el-container>
</template>
  
<script>
export default {
  beforeRouteLeave(to, from, next) {
    this.saveStore();
    next(); // 继续后续的导航解析过程
  },
  created() {
    this.pstApi.setWindowTitle("工单统计");
    this.data.user = this.pstApi.getUserData();
    if (this.$store.state.unitQuery) {
      this.query = this.$store.state.unitQuery.query;
      this.xpagination = this.$store.state.unitQuery.xpagination;
    }
    this.getPstList(); //读取分页信息
  },
  data() {
    return {
      //数据项
      data: {
        user: "", //用户数据
        psts: [], //舆情信息
      },
      //搜索栏数据
      query: {
        pstType: -1, //类别
        categorys: [], //状态
        queryString: "", //模糊字段
        isSubmit: -1,
      },
      //分页栏数据
      xpagination: {
        totalCount: 1,
        pageSize: 10,
        pageNumber: 1,
        totalPages: 1,
      },
      //导出对话框
      outputdlg: {
        title: "导出Excel文件",
        visible: false,
        width: this.ISMOBILE ? "100%" : "500px",
        selectType: 0,
        dateRangeValue: null,
        pstTypes: [],
        categorys: [],
      },
    };
  },
  methods: {
    saveStore() {
      this.$store.commit("setUnitQuery", {
        query: this.query,
        xpagination: this.xpagination,
      });
    },
    //查询方法部分
    querySubmit() {
      this.xpagination.pageNumber = 1;
      this.getPstList();
    },
    getPstList() {
      //保存store
      this.saveStore();
      this.pstApi
        .getUnitPstList(
          this.query.pstType,
          this.query.categorys,
          this.query.queryString,
          this.xpagination.pageNumber,
          this.xpagination.pageSize,
          this.query.isSubmit
        )
        .then((res) => {
          var data = res.data;
          this.data.psts = data;
          //   console.log(data);
          var pagin = JSON.parse(res.headers.xpagination);
          //console.log(pagin)
          this.xpagination.totalCount = parseInt(pagin.totalCount);
          this.xpagination.pageSize = parseInt(pagin.pageSize);
          this.xpagination.pageNumber = parseInt(pagin.currentPage);
          this.xpagination.totalPages = parseInt(pagin.totalPages);
        })
        .catch(() => {
          Toast("读取失败");
        });
    },
    //分页操作
    handleCurrentChange(val) {
      this.xpagination.pageNumber = val;
      this.getPstList();
    },
    details(pst) {
      //保存store
      this.saveStore();
      this.$router.push({ name: "HandleDetail", params: { id: pst.id } });
    },
    handle(pst) {
      //保存store
      this.saveStore();
      if (pst.status == 1) {
        this.$router.push({ name: "Reply", params: { id: pst.id } });
      } else if (pst.status == 3) {
        this.$router.push({ name: "Evidence", params: { id: pst.id } });
      }
    },
    getColorTime(row) {
      if (row.timeIntervalString) {
        let timeIntervalString = row.timeIntervalString.replace(/-/g, "");
        var reg1 = /^剩余([76543]{1,1}|[0123456789]{2,})天/;
        var reg2 = /^剩余[2]{1,1}天/;
        var color = "red";
        if (reg1.test(timeIntervalString)) {
          color = "green";
        } else if (reg2.test(timeIntervalString)) {
          color = "orange";
        }

        return `<font color=${color}>${timeIntervalString}</font>`;
      } else {
        return this.Common.dateFormatter(row.lastTime, "yyyy-MM-dd hh:mm");
      }
    },
    //导出Excel
    output() {
      //console.log(this.outputdlg);
      this.outputdlg.visible = false;
      let dateRangeValues = this.outputdlg.dateRangeValue;
      let pstTypes = this.outputdlg.pstTypes;
      let categorys = this.outputdlg.categorys;
      this.pstApi
        .exportUnitPstList(dateRangeValues, pstTypes, categorys)
        .then((res) => {
          // 处理返回的文件流
          let startTime = this.Common.dateFormatter(
            dateRangeValues[0],
            "yyyyMMdd"
          );
          let endTime = this.Common.dateFormatter(
            dateRangeValues[1],
            "yyyyMMdd"
          );
          const content = res.data;
          const fileName = `（${startTime}-${endTime}）工单导出列表.xlsx`;
          this.downloadFile(
            content,
            fileName,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          );
          this.$toast("导出成功");
        })
        .catch((error) => {
          this.$toast(error.response.data.Message);
        });
    },
    // 文件流解析并下载
    downloadFile(content, fileName, type) {
      const blob = new Blob([content], { type: type });
      if ("download" in document.createElement("a")) {
        // 非IE下载
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
    },
  },
};
</script>
  
<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
</style>